import React from 'react'
import axios from '@/utils/myAxios'
import myUploadStreamAxios from '@/utils/myUploadStreamAxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { languageTypeList } from '@/utils/constant'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    Input,
    Button,
    Table,
    Pagination,
    message,
    Modal,
    Upload,
    Form,
    Icon,
    Alert,
} from 'antd'

// 表单数据
const formData = {
    version: undefined,
    file: undefined,
}

export default class SignaturePackageDownloadConfiguration extends React.Component {
    state = {
        loading: false, // 是否加载中
        uploadFileLoading: false, // 是否上传文件加载中
        show: false, // 新增弹窗
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        formData: { ...formData }, // 表单数据
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
    };

    componentDidMount () {
        this.fetchData()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/support/channel_client_list')
            .then((res) => {
                this.setState({
                    loading: false,
                    data: res.data || []
                })
            })
    };

    /**
     * 更新
     */
    handleUpdate = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post('/v1/api/support/set_upload_ipa_info', {
                        client_channel: this.state.selectedData.id,
                        version: values.version,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["updateSuccessMessage"])
                            this.fetchData()
                            this.handleClose()
                        }
                    })
            }
        })
    };

    /**
     * 上传签名包
     */
    handleUploadConfig = ({ file }) => {
        // 获取上传url
        axios
            .get('/v1/api/support/get_upload_ipa_url', {
                params: {
                    client_channel: this.state.selectedData.id,
                    file_size: file.size,
                }
            })
            .then((res) => {
                if (res.code === 1) {
                    // 上传文件
                    this.setState({ uploadFileLoading: true })
                    myUploadStreamAxios.put(res.data, file).then((res) => {
                        this.formRef.props.form.setFieldsValue({ file: file })
                        this.setState({ uploadFileLoading: false })
                    }).catch(() => {
                        this.setState({ uploadFileLoading: false })
                    })
                }
            })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === 'update') {
            // 更新
            this.setState({
                type,
                show: true,
                title: this.props.language['updateVersion'],
                formData: {
                    version: item.version,
                },
                selectedData: { ...item },
            })
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false, formData: { ...formData } });
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column align="center" title="ID" dataIndex="id" />
                        <Table.Column align="center" title={this.props.language["channel"]} dataIndex="name" />
                        <Table.Column align="center" title={this.props.language["versionNumber"]} dataIndex="version" />
                        <Table.Column align="center" title={this.props.language["updateTime"]} dataIndex="updated_at" />
                        <Table.Column
                            align="center"
                            title={this.props.language["linkAddress"]}
                            dataIndex=""
                            render={(item) => (
                                <Button
                                    type="link"
                                    onClick={() => window.open(item.plist_url)}
                                >
                                    {item.plist_url}
                                </Button>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={120}
                            render={(item) => (
                                <>
                                    <Button
                                        className="ml10"
                                        type="primary"
                                        ghost
                                        onClick={() => this.handleShow('update', item)}
                                    >
                                        {this.props.language["update"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    formData={this.state.formData}
                    uploadFileLoading={this.state.uploadFileLoading}
                    handleUploadConfig={this.handleUploadConfig}
                    onOk={this.handleUpdate}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        /**
         * 上传前
         */
        MAX_SIZE = 256 // 最大上传大小限制
        beforeUpload = (file) => {
            const acceptList = ['.ipa']
            const isAcceptedType = file.name.endsWith(acceptList[0]);
            if (!isAcceptedType) {
                message.error(this.props.getLanguage("uploadeTypeMessage", '.ipa'))
                return false
            }
            const isAcceptedLimit = file.size / 1024 / 1024 < this.MAX_SIZE
            if (!isAcceptedLimit) {
                message.error(this.props.getLanguage("uploadeSizeMessage", this.MAX_SIZE))
                return false
            }
            return true
        };

        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["versionNumber"]}>
                                {getFieldDecorator('version', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["versionNumberVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.version
                                })(
                                    <Input
                                        maxLength={60}
                                        allowClear
                                        placeholder={this.props.language["versionNumberPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["signaturePackage"]}>
                                {getFieldDecorator('file', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["signaturePackageVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.file
                                })(
                                    <>
                                        <Upload
                                            name="file"
                                            accept=".ipa"
                                            listType="text"
                                            disabled={this.props.uploadFileLoading}
                                            showUploadList={false}
                                            beforeUpload={this.beforeUpload}
                                            customRequest={this.props.handleUploadConfig}
                                        >
                                            {getFieldValue('file') ? (
                                                <Alert style={{ cursor: "pointer" }} message={getFieldValue('file').name} type="info" />
                                            ) : (
                                                <Button>
                                                    <Icon type={this.props.uploadFileLoading ? 'loading' : 'plus'} />
                                                    Upload
                                                </Button>
                                            )}
                                        </Upload>
                                        <div
                                            style={{
                                                fontSize: '14px',
                                                color: '#999'
                                            }}
                                        >
                                            <p>{this.props.getLanguage("suggestSize", this.MAX_SIZE)} </p>
                                        </div>
                                    </>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
